@if (thumbnailUrl(); as url) {
	<span
		[tuiAvatar]="icon()"
		class="media-thumbnail__avatar"
		size="m"
		[round]="false"
	>
		<img [src]="url" alt="" />
	</span>
} @else {
	<span
		[tuiAvatar]="icon()"
		class="media-thumbnail__avatar"
		size="m"
		[round]="false"
	></span>
}
